import React,{useEffect} from "react";
import { motion } from "framer-motion";
import CountUp from "react-countup";
import { useInView } from "react-intersection-observer";
import BreadCrumb from "../Components/BreadCrumb";
import bgImg from '../Images/about-breadcrumb.webp'
import Certificates from "../Components/Certificates";
import Cta from "../Components/Cta";
import whoWeAreVideo from '../Video/iris-house-video.mp4'
import KutchMap from "../Components/KutchMap";
import BentoniteProductsTable from "../Components/BentoniteProductsTable";
import ContactSection from "../Components/ContactSection";
import JourneySection from "../Components/JourneySection";
import organizationSchema from "../Schema/OrganizationSchema";
import SchemaMarkup from "../Components/SchemaMarkup";
import breadcrumbSchema from "../Schema/BreadcrumbSchema";
import aboutPageSchema from "../Schema/AboutPageSchema";
import websiteSchema from "../Schema/WebsiteSchema";

const About=()=>{
    useEffect(() => {
            document.title =
              "About Iris Impulse India Pvt. Ltd. – Leading Mineral Exporter";
        
            const metaDesc = document.querySelector("meta[name='description']");
            if (metaDesc) {
              metaDesc.setAttribute(
                "content",
                "Learn about Iris Impulse India Pvt. Ltd., a trusted manufacturer, exporter & supplier of bentonite and industrial minerals with global reach & a commitment to quality."
              );
            }
        
         const canonical = document.querySelector("link[rel='canonical']");
          if (canonical) {
            canonical.setAttribute("href", "https://irisimpulse.com/about-us");
          }
        
          const ogTitle = document.querySelector("meta[property='og:title']");
          if (ogTitle) {
            ogTitle.setAttribute(
              "content",
              "About Iris Impulse India Pvt. Ltd. – Leading Mineral Exporter"
            );
          }
        
            const ogDesc = document.querySelector("meta[property='og:description']");
          if (ogDesc) {
            ogDesc.setAttribute(
              "content",
              "Learn about Iris Impulse India Pvt. Ltd., a trusted manufacturer, exporter & supplier of bentonite and industrial minerals with global reach & a commitment to quality."
            );
          }
        
          const ogUrl = document.querySelector("meta[property='og:url']");
          if (ogUrl) {
            ogUrl.setAttribute("content", "https://irisimpulse.com/about-us");
          }
        
          const ogImage = document.querySelector("meta[property='og:image']");
          if (ogImage) {
            ogImage.setAttribute(
              "content",
              "https://irisimpulse.com/Images/about.webp"
            );
          }
        
            const twitterTitle = document.querySelector("meta[name='twitter:title']");
          if (twitterTitle) {
            twitterTitle.setAttribute(
              "content",
              "About Iris Impulse India Pvt. Ltd. – Leading Mineral Exporter"
            );
          }
        
            const twitterDesc = document.querySelector(
            "meta[name='twitter:description']"
          );
          if (twitterDesc) {
            twitterDesc.setAttribute(
              "content",
              "Learn about Iris Impulse India Pvt. Ltd., a trusted manufacturer, exporter & supplier of bentonite and industrial minerals with global reach & a commitment to quality."
            );
          }
        
            const twitterImage = document.querySelector("meta[name='twitter:image']");
          if (twitterImage) {
            twitterImage.setAttribute(
              "content",
              "https://irisimpulse.com/Images/about.webp"
            );
          }
          }, []);

  const { ref: statsRef, inView: statsInView } = useInView({
    triggerOnce: true,
    threshold: 0.4,
  });

  // Safe animations (no x movement to avoid layout breaking)
  const fadeUp = {
    hidden: {
      opacity: 0,
      y: 40,
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
        ease: "easeOut",
      },
    },
  };

  const staggerContainer = {
    hidden: {},
    visible: {
      transition: {
        staggerChildren: 0.2,
      },
    },
  };

  const organizationData = organizationSchema();
  const breadcrumbData = breadcrumbSchema({
  items: [
    {
      name: "Home",
      url: "https://irisimpulse.com/",
    },
    {
      name: "About Us",
    },
  ],
});
  const aboutPageData = aboutPageSchema({
  url: "https://irisimpulse.com/about-us/",
  title: "About Iris Impulse India Pvt. Ltd. – Leading Mineral Exporter",
  description:
    "Learn about Iris Impulse India Pvt. Ltd., a trusted manufacturer, exporter & supplier of bentonite and industrial minerals with global reach & a commitment to quality.",
  image: "https://irisimpulse.com/Images/about.webp",
});
const websiteData = websiteSchema();
    return(
        <>

      <SchemaMarkup data={organizationData} />
      <SchemaMarkup data={breadcrumbData} />
      <SchemaMarkup data={aboutPageData} />
      <SchemaMarkup data={websiteData} />

        <BreadCrumb
  title="About Iris Impulse India" 
  bgImage={bgImg} 
/>
      <div className="who-section-padding"></div>
        {/**WHO WE ARE SECTION */}
     <section className="who-section">
      <div className="container">

        {/* Left Image */}
        <motion.div
  className="who-image-wrapper who-section-vdo-wrapper"
>
  <motion.video
    className="who-image who-section-vdo"
    autoPlay
    loop
    muted
    playsInline
    preload="metadata"
  >
    <source src={whoWeAreVideo} type="video/mp4" />
    Your browser does not support the video tag.
  </motion.video>
</motion.div>

        {/* Right Content Card */}
        <motion.div
          className="mining-card"
          variants={fadeUp}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.2 }}
        >
            <div className="mining-card-inner">
          <motion.h2
            className="section-heading"
            variants={fadeUp}
          >
            WHO WE ARE ?
          </motion.h2>

          <motion.p
            className="section-text"
            variants={fadeUp}
          >
            <b className="bold">“IRIS”</b> manages a diversified portfolio of corporate holdings.
          </motion.p>

          <motion.p
            className="section-text"
            variants={fadeUp}
          >
            Starting the journey from Mining in the year 1991,  <b className="bold">“IRIS”</b> is
            continously diversifying it’s businesses in various sectors. From
            the extraction, processing and distribution of industrial mineral
            products, such as bentonite, to logistics activities. Our
            development and innovation efforts are always intended to safeguard
            our planet's natural heritage and the wellbeing of the communities
            in which we operate.
          </motion.p>

          <motion.p
            className="section-text"
            variants={fadeUp}
          >
            We our ongoing quest we treat ourselves as a guardian of the
            nature, by responsible solutions for people, pets and the planet.
          </motion.p>

          <motion.h2
            className="section-heading"
            variants={fadeUp}
          >
            EXPERIENCE THAT BUILDS TRUST
          </motion.h2>

          <motion.p
            className="section-text"
            variants={fadeUp}
          >
            With decades of industry experience, we have proudly served clients
            across the globe and successfully delivered projects for businesses
            in multiple industries. Our commitment to quality, innovation, and
            dependable execution helps organizations grow, scale, and achieve
            long-term success.
          </motion.p>

          {/* Stats */}
          <motion.div
            className="who-stats"
            ref={statsRef}
            variants={staggerContainer}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.3 }}
          >

            <motion.div
              className="who-stat"
              variants={fadeUp}
            >
              <h3>
                {statsInView && <CountUp end={25} duration={3} />}+
              </h3>

              <p className="section-text">
                Years Of  Experience
              </p>
            </motion.div>

            <motion.div
              className="who-stat"
              variants={fadeUp}
            >
              <h3>
                {statsInView && <CountUp end={500} duration={3} />}+
              </h3>

              <p className="section-text">
                Global  Clients
              </p>
            </motion.div>

            <motion.div
              className="who-stat"
              variants={fadeUp}
            >
              <h3>
                {statsInView && <CountUp end={40} duration={3} />}+
              </h3>

              <p className="section-text">
                Products for  Various Application
              </p>
            </motion.div>

          </motion.div>
          </div>
        </motion.div>
      </div>
    </section>
     <div className="who-section-padding"></div>

    {/**GLOBAL MINERAL SOLUTIONS ROOTED IN KUTCH SECTION */}
    <KutchMap />

    {/**MISSION VISION SECTION */}
   <section className="mission-section">
  <div className="container">

    <motion.h2
      className="section-heading"
      variants={fadeUp}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.3 }}
    >
      VISION & MISSION
    </motion.h2>

    <motion.div
      className="mission-grid"
      variants={staggerContainer}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.2 }}
    >

      {/* Vision Card */}
      <motion.div
        className="mission-card-special  card-2"
        variants={fadeUp}
        whileHover={{
          y: -15,
          transition: { duration: 0.1 },
        }}
      >
        <div className="mission-card-special-inner">
        <h3 className="card-heading">OUR VISION</h3>

        <p className="section-text">
          <b className="bold">Inches Makes Champions</b> <br />
          Our Goal is simply stated :
        </p>

        <ul>
          {[
            "We want to be the best service organization in the world.",
            "So long as space remains,",
            "So long as sentient beings remain,",
            "we will remain, in order to help, in order to serve, in order to make our contribution.",
            "“No great things created suddenly.”",
            "Inches make champions.",
            "Do first thing first & second thing not at all to be champion.",
          ].map((item, index) => (
            <motion.li
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{
                duration: 0.5,
                delay: index * 0.08,
              }}
            >
              {item}
            </motion.li>
          ))}
        </ul>
        </div>
      </motion.div>

      {/* Mission Card */}
      <motion.div
        className="mission-card-special"
        variants={fadeUp}
        whileHover={{
          y: -15,
          transition: { duration: 0.1 },
        }}
      >
        <div className="mission-card-special-inner">
        <h3 className="card-heading">OUR MISSION</h3>

        <p className="section-text">
          Our mission is to be recognized and respected as one of the
          premier associations to grow personally, professionally,
          emotionally and spiritually by using our compassion, our unique
          perspective and our belief in others inherent goodness,
          integrity, and enormous potential. The basic proposition of our
          business is simple, solid and timeless. In order to realize our
          vision, our mission must be to exceed the expectations of our
          customers, whom we define as guests, partners and fellow
          employees. Everything we do is inspired by our enduring mission :
        </p>

        <ul>
          {[
            "To refresh the world in body, mind and spirit",
            "To inspire moments of optimism through our brands and our actions",
            "To create value and make a difference everywhere we engage.",
          ].map((item, index) => (
            <motion.li
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{
                duration: 0.5,
                delay: index * 0.08,
              }}
            >
              {item}
            </motion.li>
          ))}
        </ul>
        </div>
      </motion.div>

    </motion.div>
  </div>
</section>

            {/**OUR JOURNEY SECTION */}
            <JourneySection />


    {/**OUR KEY PRODUCTS TABLE */}
    <BentoniteProductsTable />

       
    {/**CTA SECTION */}
    <Cta />

    {/**CERTIFICATES SECTION */}
    <Certificates/>

    {/**CONTACT FORM SECTION */}
    <ContactSection />
    

        </>
    )
}
export default About;